"use strict";
// PUBLIC ACCESS
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLES_PERMISSIONS = exports.COMPANY_USER2 = exports.COMPANY_SUPERADMIN2 = exports.COMPANY_ADMIN2 = exports.SYSTEM_ADMIN = exports.REQUIRES_SETUP_COMPLETE_CURRENCY = exports.SEC_MANAGE_COMPANY_USERS = exports.SEC_MANAGE_ANY_USERS = exports.SEC_MANAGE_PERMISSIONS = exports.SEC_MANAGE_SYSTEM_PARAMETERS = exports.SEC_MANAGE_COMPANY_SETTINGS = exports.SEC_IMPERSONATE_COMPANY_USER = exports.SEC_IMPERSONATE_ANY_USER = exports.SEC_ALL_DATA_RFQ = exports.SEC_ALL_DATA_LISTING = exports.SEC_OWNER_RFQ = exports.SEC_OWNER_LISTING = exports.SEC_PUBLIC_RFQ = exports.SEC_PUBLIC_LISTING = void 0;
// Read only access to public data for listings.
exports.SEC_PUBLIC_LISTING = 'SEC_PUBLIC_LISTING';
// Read only access to public data for RfQs.
exports.SEC_PUBLIC_RFQ = 'SEC_PUBLIC_RFQ';
// OWNER ACCESS
// Access to all owner data for listings.
exports.SEC_OWNER_LISTING = 'SEC_OWNER_LISTING';
// Access to all owner data for RfQs.
exports.SEC_OWNER_RFQ = 'SEC_OWNER_RFQ';
// ALL - DATA ACCESS
// Read only access to all data for listings.
exports.SEC_ALL_DATA_LISTING = 'SEC_ALL_DATA_LISTING';
// Read only access to all data for RfQs.
exports.SEC_ALL_DATA_RFQ = 'SEC_ALL_DATA_RFQ';
// IMPERSONATE
// Able to impersonate any user.
exports.SEC_IMPERSONATE_ANY_USER = 'SEC_IMPERSONATE_ANY_USER';
// Able to impersonate users in own company.
exports.SEC_IMPERSONATE_COMPANY_USER = 'SEC_IMPERSONATE_COMPANY_USER';
// COMPANY ADMIN
// Manage company specific configuration.
exports.SEC_MANAGE_COMPANY_SETTINGS = 'SEC_MANAGE_COMPANY_SETTINGS';
// SYSTEM ADMIN
// Manage system parameters, like transport cost, transport duration. System wide configuration.
exports.SEC_MANAGE_SYSTEM_PARAMETERS = 'SEC_MANAGE_SYSTEM_PARAMETERS';
// Manage roles.
exports.SEC_MANAGE_PERMISSIONS = 'SEC_MANAGE_PERMISSIONS';
// Manage any user.
exports.SEC_MANAGE_ANY_USERS = 'SEC_MANAGE_ANY_USERS';
// Manage users in own company. Create, update, disable.
exports.SEC_MANAGE_COMPANY_USERS = 'SEC_MANAGE_COMPANY_USERS';
// Set of permissions that require currency setup
exports.REQUIRES_SETUP_COMPLETE_CURRENCY = [exports.SEC_PUBLIC_LISTING, exports.SEC_PUBLIC_RFQ, exports.SEC_OWNER_LISTING, exports.SEC_OWNER_RFQ];
// Roles
exports.SYSTEM_ADMIN = 'SYSTEM_ADMIN';
exports.COMPANY_ADMIN2 = 'COMPANY_ADMIN2';
exports.COMPANY_SUPERADMIN2 = 'COMPANY_SUPERADMIN2';
exports.COMPANY_USER2 = 'COMPANY_USER2';
// Permissions for roles
exports.ROLES_PERMISSIONS = {
    COMPANY_ADMIN2: [exports.SEC_MANAGE_COMPANY_SETTINGS, exports.SEC_OWNER_LISTING, exports.SEC_OWNER_RFQ, exports.SEC_PUBLIC_LISTING, exports.SEC_PUBLIC_RFQ],
    COMPANY_SUPERADMIN2: [
        exports.SEC_MANAGE_COMPANY_SETTINGS,
        exports.SEC_MANAGE_COMPANY_USERS,
        exports.SEC_OWNER_LISTING,
        exports.SEC_OWNER_RFQ,
        exports.SEC_PUBLIC_LISTING,
        exports.SEC_PUBLIC_RFQ,
    ],
    COMPANY_USER2: [exports.SEC_OWNER_LISTING, exports.SEC_OWNER_RFQ, exports.SEC_PUBLIC_LISTING, exports.SEC_PUBLIC_RFQ],
    SYSTEM_ADMIN: [
        exports.SEC_ALL_DATA_LISTING,
        exports.SEC_ALL_DATA_RFQ,
        exports.SEC_IMPERSONATE_ANY_USER,
        exports.SEC_MANAGE_ANY_USERS,
        exports.SEC_MANAGE_PERMISSIONS,
        exports.SEC_MANAGE_SYSTEM_PARAMETERS,
    ],
};
